export const tplLib = {
  // 这个是 demo
  9999: {
    tplName: 'demo', // 这个会作为 store 命名空间的名字，也会传递给模板入口组件
    store: () =>
      import('@/components/templates/demo/store').then(
        module => module.default
      ),
    routes: () =>
      import('@/components/templates/demo/routes').then(
        module => module.default
      )
  },
  0: {
    tplName: 'lottery',
    store: () =>
      import('@/components/templates/lottery/store').then(
        module => module.default
      ),
    routes: () =>
      import('@/components/templates/lottery/routes').then(
        module => module.default
      ),
    i18n: () => import('@/components/templates/lottery/i18n/setup')
  },
  4: {
    tplName: 'eInvite',
    store: () =>
      import('@/components/templates/eInvite/store').then(
        module => module.default
      ),
    routes: () =>
      import('@/components/templates/eInvite/routes').then(
        module => module.default
      )
  },
  5: {
    tplName: 'coupon',
    store: () =>
      import('@/components/templates/coupon/store').then(
        module => module.default
      ),
    routes: () =>
      import('@/components/templates/coupon/routes').then(
        module => module.default
      )
  },
  6: {
    tplName: 'inviteEarnCoupon',
    store: () =>
      import('@/components/templates/inviteEarnCoupon/store').then(
        module => module.default
      ),
    routes: () =>
      import('@/components/templates/inviteEarnCoupon/routes').then(
        module => module.default
      )
  }
};
